export const autoLogoutModule = {
    state: {
        session: {
            dialogues: {
                countdown: {
                    show: false,
                    timeLeft: "01:00 minute",
                },
            },
            timers: {
                auto_logout: {
                    timer: null,
                    duration: 900, // 15 mins
                },
                check_logout: {
                    timer: null,
                    duration: 840, // 14 mins
                },
                countdown: {
                    timer: null,
                    timeout: 0,
                }
            },
            auth: {
                refreshInterval: 300, // 5 mins
                tokenTime: null,
            }
        },
    },
    getters: {
        getCountdownTimeleft: state => state.session.dialogues.countdown.timeLeft,
    },
    mutations: {
        setCountdownTimeout(state, data) {
            state.session.timers.countdown.timeout = data.timeout;
        },
        setCountdownTimeleft(state, data) {
            // data.timeout is the number of seconds, as an integer, until logout
            var timeout = data.timeout;
            var minutes = parseInt(timeout / 60, 10);
            var seconds = parseInt(timeout % 60, 10);

            // pad the minute and second values if they are under 10 with a leading 0
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            // commit formatted time left value to state
            state.session.dialogues.countdown.timeLeft = (minutes > 0) ? (minutes + ":" + seconds + " minutes") : (seconds + " seconds");
        },
        setCountdownDialogue(state, data) {
            state.session.dialogues.countdown.show = data.show;
        },
        updateTokentime(state, data) {
            state.session.auth.tokenTime = data.tokenTime;
        },
    },
    actions: {
        refreshSessionTimers({ dispatch, commit }) {
            // reset all timers
            dispatch('clearTimers').autoLogoutModule;

            console.log("autoLogout: refresh session timers");

            // calculate time between last token refresh and now
            var auth = this.state.autoLogoutModule.session.auth;
            
            var lastTokentime = auth.tokenTime
            var currentDatetime = Date.now();
            var timeDiff = (currentDatetime - lastTokentime) / 1000;

            // if time diff is greater than refresh interval then update token,
            // prevents spamming requests on every user action, default 5 mins
            let refreshInterval = auth.refreshInterval;
            if (timeDiff > refreshInterval) {
                dispatch('autoLogin').then(response => {
                    console.log("autoLogout: update auth token, res:", response);
                    if(response) {
                        // update last refresh time if successful response
                        console.log("autoLogout: updated auth token");
                        commit('updateTokentime', {tokenTime: currentDatetime});
                    } else {
                        // log out if auth refresh fails
                        console.log("autoLogout: unable to update auth token, logout");
                        dispatch('logout');
                    }
                });
            }

            // get timers and durations from state
            var timers = this.state.autoLogoutModule.session.timers;
            var auto_logout_duration = timers.auto_logout.duration;
            var check_logout_duration = timers.check_logout.duration;

            // set timeout to execute after auto_logout_duration(s)
            // timeout will clear all timers then logout
            timers.auto_logout.timer = setTimeout(() => {
                console.log("autoLogout: user session timed out!");
                dispatch('clearTimers').autoLogoutModule;
                dispatch("logout");
            }, auto_logout_duration * 1000)

            // set timeout to execute after check_logout_duration(s)
            // timeout will start the countdown to logout timer
            // and display the countdown dialogue over the current view
            timers.check_logout.timer = setTimeout(() => {
                console.log("autoLogout: user session about to time out!");
                commit('setCountdownDialogue', {show: true});
                dispatch('startCountdown').autoLogoutModule;
            }, check_logout_duration * 1000)

            console.log("autoLogout: set timeout timers", timers);
        },

        startCountdown({ commit }) {
            // get timers from state, then calculate time difference between the
            // two logout duration values, this will give the duration of the countdown timer
            var timers = this.state.autoLogoutModule.session.timers;
            var timeout = (timers.auto_logout.duration - timers.check_logout.duration);

            // commit the timeout interval to the state, and pass the timeout into the
            // timeleft commit that formats into mm:ss until logout text
            commit('setCountdownTimeout', {timeout: timeout});
            commit('setCountdownTimeleft', {timeout: timeout});

            console.log("autoLogout: start countdown");
            
            // create 1s interval timer
            timers.countdown.timer = setInterval(() => {
                // get current timeout interval
                var currentTimeout = timers.countdown.timeout;
                // decrease timeout interval by 1, equivalent to 1s
                currentTimeout--;
                // commit updated timeout value to state
                commit('setCountdownTimeout', {timeout: currentTimeout});
                commit('setCountdownTimeleft', {timeout: currentTimeout});
            }, 1000)
        },
        
        clearTimers({ commit }) {
            // get current timer's state
            var timers = this.state.autoLogoutModule.session.timers;

            console.log("autoLogout: clear timers");

            // clear the timeout and interval timers to prevent them running in the background
            // and from duplicating them
            clearTimeout(timers.auto_logout.timer);
            clearTimeout(timers.check_logout.timer);
            clearInterval(timers.countdown.timer);

            // hide the countdown expiration dialogue as logout countdown has stopped
            commit('setCountdownDialogue', {show: false});
        },
    },
};